'use client';

import { c as _c } from "react/compiler-runtime";
import './gallery-airbnb.scss';
import { formatDuration } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { FlexibleContentProps } from '@sola/schema/lib/schema.ts';
import { getHeaderDisplayLevel } from '@sola/utils/assembly.ts';
import { Image } from '../../../atoms/image/image.tsx';
import { FeatureCard } from '../../../molecules/feature-card/feature-card.tsx';
import { HeaderGroup } from '../../../molecules/header-group/header-group.tsx';
import { Lightbox, LightboxTrigger } from '../../../molecules/lightbox/lightbox.tsx';
import { getPlaceholderItems } from '../../../utils/storybook.tsx';
import { getBaseSizeProps } from '../../../utils/text-utils.tsx';
export const GalleryAirBnb: React.FC<FlexibleContentProps> = t0 => {
  const $ = _c(34);
  let items;
  let media;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      seoLevel: t1,
      media,
      items,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = items;
    $[2] = media;
    $[3] = props;
    $[4] = t1;
  } else {
    items = $[1];
    media = $[2];
    props = $[3];
    t1 = $[4];
  }
  const seoLevel = t1 === undefined ? 2 : t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["skippy"];
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    t
  } = useTranslation(t2);
  const hasHeaderContent = !!props.title || !!props.body;
  const hasHeaderCard = hasHeaderContent && media?.image;
  const hasHeaderGroup = hasHeaderContent && !media?.image;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[6] !== hasHeaderCard || $[7] !== hasHeaderGroup || $[8] !== items || $[9] !== media || $[10] !== props || $[11] !== seoLevel || $[12] !== t) {
    const headerDisplayLevel = getHeaderDisplayLevel(seoLevel);
    const galleryItems = !items || items.length < 3 ? getPlaceholderItems(items, 3) : items;
    t8 = "GalleryAirBnb component";
    t5 = "GalleryAirBnb__container container flex flex-col gap-comfy-xl lg:gap-roomy-xs";
    t6 = hasHeaderCard && <FeatureCard {...props} {...getBaseSizeProps(headerDisplayLevel)} seoLevel={seoLevel} media={media} imagePlacement="right" variant="horizontal" inline={true} />;
    if ($[19] !== hasHeaderGroup || $[20] !== props || $[21] !== seoLevel) {
      t7 = hasHeaderGroup && <HeaderGroup {...props} seoLevel={seoLevel} />;
      $[19] = hasHeaderGroup;
      $[20] = props;
      $[21] = seoLevel;
      $[22] = t7;
    } else {
      t7 = $[22];
    }
    t3 = "GalleryAirBnb__grid gap-snug-xl lg:gap-comfy-sm";
    t4 = galleryItems.slice(0, 3).map((slide, index) => <div key={["slide", index, slide.title].join("-")} className="GalleryAirBnb__grid-item"><Lightbox key={["lightbox", index, slide.title].join("-")} items={galleryItems} startIndex={index}><LightboxTrigger className="Lightbox__trigger w-full h-full" ariaLabel={t("skippy:gallery.open")}><div className="GalleryAirBnb__image">{index === 2 && <div className="GalleryAirBnb__overlay label-potent label-md md:label-lg lg:label-xl"><span className="flex items-center gap-snug-lg md:gap-snug-xl lg:gap-comfy-xs">{t("skippy:gallery.seeMore")}<ArkIcon iconName="arrow-right" className="GalleryAirBnb__icon" /></span></div>}{index !== 2 && slide.media?.video && <div className="Carousel__video-thumb"><div className="Carousel__video-thumb__overlay" /><div className="Carousel__video-thumb__info">{slide.media.video.duration && <div className="label-xl label-potent p-comfy-lg">{formatDuration(slide.media.video.duration)}</div>}</div><div className="Carousel__video-thumb__play"><ArkIcon iconName="play" /></div></div>}<Image image={slide.media?.image} hasPlaceholder={true} aspectRatio={index === 0 ? "4-3" : undefined} /></div></LightboxTrigger></Lightbox></div>);
    $[6] = hasHeaderCard;
    $[7] = hasHeaderGroup;
    $[8] = items;
    $[9] = media;
    $[10] = props;
    $[11] = seoLevel;
    $[12] = t;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
  }
  let t9;
  if ($[23] !== t3 || $[24] !== t4) {
    t9 = <div className={t3}>{t4}</div>;
    $[23] = t3;
    $[24] = t4;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t5 || $[27] !== t6 || $[28] !== t7 || $[29] !== t9) {
    t10 = <div className={t5}>{t6}{t7}{t9}</div>;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t10 || $[32] !== t8) {
    t11 = <section className={t8}>{t10}</section>;
    $[31] = t10;
    $[32] = t8;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  return t11;
};